export enum SpreadsheetDimensionDirections {
    Horizontal,
    Vertical
}